import { Component, OnInit } from '@angular/core';
import { CustomersService } from 'src/app/services/core/quickbook/customers/customers.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { onTimeChange } from 'src/app/utils/utils.common';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceService } from 'src/app/services/core/quickbook/invoices/invoice.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import * as moment from 'moment';
import { ProductServiceService } from 'src/app/services/core/quickbook/product-services/product-service.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { forkJoin, Subject, debounceTime, filter } from 'rxjs';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { match } from 'assert';
import { sweetAlert } from 'src/app/utils/swal';
import * as _ from 'lodash';
import { NUMBER_OF_RECORDS, getCompanyEmail } from 'src/app/utils/common.utils';
import { on } from 'events';
import { LineItemType } from 'src/app/enums/enums';
import { TitleCasePipe } from '@angular/common';
@UntilDestroy()
@Component({
  selector: 'app-add-invoice',
  templateUrl: './add-invoice.component.html',
  styleUrls: ['./add-invoice.component.css']
})
export class AddInvoiceComponent implements OnInit {
  invoiceForm!: FormGroup;
  invoiceItemForm!: FormGroup;
  submitted = false;
  lineItemSubmitted = false;
  lineItemFormSubmitted = false;
  invoiceId: any;
  user: any;
  customers: any;
  allCustomers: any[] = [];
  productItems: any;
  preProductItems: any = {};
  selectedDate: any;
  trips: any = [];
  filteredTrips: any = [];
  selectedTrip: any = null;
  tripId: any;
  preLevelOfService: any = {};
  preSpacetypes: any = {};
  preAddons: any = {};
  preFundingSource: any;
  invoiceData: any;
  selectedTrips: any = [];
  showTrips = true;

  selectedFundingSource: any = null;
  fundingSourceList: any;
  isLineItemOnlyDescription = false;
  globalLineItemType = LineItemType.SALES_ITEM;
  readonly LineItemType = LineItemType;
  titleCase = new TitleCasePipe();

  constructor(
    private tripService: TripService,
    private productService: ProductServiceService,
    private credentialService: CredentialService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private customerService: CustomersService,
    private invoiceServices: InvoiceService,
    private sharedDataService: SharedDataService,
    private levelOfService: LosService,
    private spaceTypeService: SpaceTypeService,
    private addonService: AddonService,
    private fundingSource: FundingSourceService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.invoiceId = params["id"];
        if (this.invoiceId) {
          this.getInvoiceId();
        }
      });

    this.invoiceForm = this.fb.group({
      CustomerRef: this.fb.group({
        name: [''],
        value: ['', Validators.required]
      }),
      reference: this.fb.group({
        name: [''],
        id: [''],
      }),
      DueDate: [''],
      Line: this.fb.array([], Validators.required),
      BillEmail: this.fb.group({
        Address: ['', Validators.email]
      })
    });

    this.invoiceItemForm = this.fb.group({
      DetailType: ['SalesItemLineDetail', Validators.required],
      Description: [''],
      reference: this.fb.group({
        name: [''],
        id: [''],
        type: ['']
      }),

      Amount: [0, [Validators.required, Validators.min(1)]],
      SalesItemLineDetail: this.fb.group({
        ItemRef: this.fb.group({
          name: [''],
          value: ['', Validators.required],
        }),
        Qty: [0, [Validators.required, Validators.min(1)]],
        UnitPrice: [0, [Validators.required, Validators.min(1)]],
        ServiceDate: ['', Validators.required]
      }),
      type: ['normal', Validators.required]
    });

    this.getUser();
  }

  selectedTripsTotal = 0;

  get lineItems() {
    return this.invoiceForm.get('Line') as FormArray;
  }

  get form() {
    return this.invoiceForm.controls
  }

  get itemForm() {
    return this.invoiceItemForm.controls
  }

  get BillEmail() {
    return this.invoiceForm.get('BillEmail') as FormGroup;
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        const companyEmail = getCompanyEmail(this.user?.company);
        if (companyEmail && !this.invoiceForm.get('BillEmail.Address')?.value) {
          this.invoiceForm.get('BillEmail.Address')?.patchValue(companyEmail);
        }
        this.invoiceForm.patchValue({
          DueDate: moment().tz(this.user.timeZone).add(1, 'month').toISOString()
        })
        this.invoiceItemForm.patchValue({
          SalesItemLineDetail: {
            ServiceDate: moment().tz(this.user.timeZone).toISOString()
          }
        })

        this.loadInitialData();
        this.invoiceItemForm.get('SalesItemLineDetail.ItemRef.value')?.valueChanges.subscribe((item: any) => {
          if (item) {

          }
          this.invoiceItemForm.patchValue({

            Amount: (item || 0) * (this.invoiceItemForm.value.SalesItemLineDetail.Qty || 0),
            SalesItemLineDetail: {
              UnitPrice: item
            }
          })
        });
        this.invoiceItemForm.get('SalesItemLineDetail.Qty')?.valueChanges.subscribe((item: any) => {
          this.invoiceItemForm.patchValue({
            Amount: (item || 0) * (this.invoiceItemForm.value.SalesItemLineDetail.UnitPrice || 0),
          })
        });

        this.invoiceItemForm.get('SalesItemLineDetail.UnitPrice')?.valueChanges.subscribe((item: any) => {
          this.invoiceItemForm.patchValue({
            Amount: (item || 0) * (this.invoiceItemForm.value.SalesItemLineDetail.Qty || 0),
          })
        });

      }
    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      levelOfService: this.levelOfService.getPicker(queryparams),
      spaceTypes: this.spaceTypeService.getPicker(queryparams),
      addons: this.addonService.getAddons(queryparams),
      fundingSource: this.fundingSource.getPicker(queryparams),
    }).pipe(untilDestroyed(this))
      .subscribe(({ levelOfService, spaceTypes, addons, fundingSource }: any) => {

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
        if (spaceTypes?.results?.length) {
          this.preSpacetypes = spaceTypes.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
        if (addons?.results?.length) {
          this.preAddons = addons.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Space Types
        if (fundingSource?.results?.length) {
          this.fundingSourceList = fundingSource?.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
          this.preFundingSource = fundingSource.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
        this.getAllCustomers();
        this.getProductItems();
      });
  }

  getAllCustomers() {
    this.customers = null;
    let queryParams = {
      limit: 9999
    }
    this.customerService.getCustomers(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.allCustomers = data.results || [];
          this.customers = this.allCustomers.filter((customer: any) => customer.Id && customer.Id !== 'undefined');
          //   this.preCustomers = this.customers.reduce((obj: any, item: any) => {
          //   obj[item.id] = item;
          //   return obj;
          // }, {});
        }
      })
  }

  getInvoiceId() {
    this.invoiceServices.getInvoiceById(this.invoiceId).subscribe((data: any) => {
      if (data) {
        this.invoiceData = data;
        const customerValue = data.CustomerRef?.value && data.CustomerRef.value !== 'undefined'
          ? data.CustomerRef.value
          : '';
        this.invoiceForm.patchValue({
          CustomerRef: { name: data.CustomerRef?.name || '', value: customerValue }
        });
        this.invoiceForm.get('reference')?.patchValue({
          id: data.reference.id,
          name: data.reference.name
        })
        this.invoiceForm.get('BillEmail')?.patchValue({
          Address: data?.BillEmail?.Address,
        })

        const lineItems = this.invoiceForm.get('Line') as FormArray;
        const lines = data.Line.filter((line: any) => line.DetailType !== 'SubTotalLineDetail');
        lines.sort((a: any, b: any) => (a.reference?.priority || 0) - (b.reference?.priority || 0));

        lines.forEach((line: any) => {
          if (line.DetailType === LineItemType.SALES_ITEM) {
            lineItems.push(this.fb.group({
              DetailType: [line.DetailType],
              Amount: [line.Amount, [Validators.required, Validators.min(1)]],
              Description: [line.Description],
              SalesItemLineDetail: this.fb.group({
                ItemRef: this.fb.group({
                  name: [line.SalesItemLineDetail?.ItemRef?.name || ''],
                  value: [line.SalesItemLineDetail?.ItemRef?.value || '', Validators.required],
                }),
                Qty: [line.SalesItemLineDetail?.Qty, [Validators.required, Validators.min(1)]],
                UnitPrice: [line.SalesItemLineDetail?.UnitPrice || '', [Validators.required, Validators.min(1)]],
                ServiceDate: [line.SalesItemLineDetail?.ServiceDate || this.invoiceData.DueDate, Validators.required]
              }),
              // moment(line.SalesItemLineDetail?.ServiceDate).tz(this.user.timeZone).format('MM/DD/YYYY')
            }));
          } else {
            lineItems.push(this.fb.group({
              DetailType: [line.DetailType],
              Description: [line.Description, Validators.required],
              reference: this.fb.group({
                name: [{ value: '', disabled: true }],
                id: [{ value: '', disabled: true }],
                type: [{ value: '', disabled: true }],
                priority: [{ value: '', disabled: true }]
              }),
              Amount: [{ value: 0, disabled: true }],
              SalesItemLineDetail: this.fb.group({
                ItemRef: this.fb.group({
                  name: [{ value: '', disabled: true }],
                  value: [{ value: '', disabled: true }],
                }),
                Qty: [{ value: 0, disabled: true }],
                UnitPrice: { value: 0, disabled: true },
                ServiceDate: [{ value: '', disabled: true }]
              })
            }));
          }
        });
      }
    });
  }

  onSave() {
    console.log('Form Object:', this.invoiceForm)
    console.log('Form Object:', this.invoiceForm.value);
    this.submitted = true;
    this.lineItemSubmitted = true;
    if (this.invoiceForm.invalid) return;

    const payload = this.invoiceForm.value;
    payload.TxnDate = payload.TxnDate || this.invoiceData?.TxnDate || new Date().toISOString();
    if (!payload?.CustomerRef?.value || payload.CustomerRef.value === 'undefined') {
      sweetAlert('Error', 'Select a customer that is already synced to QuickBooks.', 'error', 'Ok');
      return;
    }
    if (this.invoiceData && this.invoiceId) {
      payload.Id = this.invoiceData.Id;
    }
    this.invoiceServices.saveInvoice(this.invoiceId, payload).subscribe((data: any) => {
      if (data) {
        this.router.navigateByUrl('/quickbook/invoices')
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    }

    );
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  onChangeCustomer(customerId: any) {
    if (!customerId) return;
    const selected = this.customers.find((cust: any) => customerId == cust.Id);
    if (!selected) return;
    this.invoiceForm.patchValue({
      CustomerRef: { name: selected.DisplayName, value: selected.Id },
      BillEmail: { Address: selected?.PrimaryEmailAddr?.Address || getCompanyEmail(this.user?.company) || '' }
    })
  }

  getProductItems() {
    let queryParams = {
      limit: 9999,
      status: 'created'
      // page,
    }
    this.productService.getProductServices(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.productItems = data.results
          this.productItems = this.productItems.filter((item: any) => item.Type === 'Service' || item.Type === 'Inventory');
          this.preProductItems = this.productItems.reduce((obj: any, item: any) => (obj[item.Id] = item, obj), {});

        }
      })
  }

  // ======================= Line Item Starts =======================
  onSelectType(event: any) {
    this.invoiceItemForm = this.createLineItemForm(event.target.value);
  }

  onSelectService(event: any) {
    if (this.invoiceItemForm.get('DetailType')?.value !== LineItemType.SALES_ITEM) {
      return;
    }
    if (!event.target.value) {
      this.clearLineItem();
      return;
    }
    const product = this.preProductItems[event.target?.value];
    if (!product) return;

    let quantity = this.invoiceItemForm.value.SalesItemLineDetail.Qty;

    this.invoiceItemForm.patchValue({
      Description: this.preProductItems[event.target?.value]?.Description || '',
      SalesItemLineDetail: {
        ItemRef: { value: event.target?.value, name: this.preProductItems[event.target?.value]?.IncomeAccountRef?.name },
        Qty: quantity,
        UnitPrice: this.preProductItems[event.target?.value]?.UnitPrice || 0,
        ServiceDate: this.preProductItems[event.target?.value]?.ServiceDate ? moment(this.preProductItems[event.target?.value]?.ServiceDate).tz(this.user.timeZone).toISOString() : moment().tz(this.user.timeZone).toISOString()
      },
      reference: {
        name: this.preProductItems[event.target?.value]?.reference?.name || '',
        id: this.preProductItems[event.target?.value]?.reference?.id || '',
        type: this.preProductItems[event.target?.value]?.reference?.type || ''
      },
      Amount: this.calculateProductAmount(product.UnitPrice, quantity) || 0,
    });
  }

  addLineItem() {
    this.lineItemFormSubmitted = true;
    if (this.invoiceItemForm.invalid) {
      return;
    }
    const lineItem = this.createLineItemForm(this.invoiceItemForm.value.DetailType);
    // lineItem.get('DetailType')?.disable();
    lineItem.patchValue({ ...this.invoiceItemForm.value })
    this.lineItems.push(lineItem);

    this.invoiceItemForm = this.createLineItemForm(LineItemType.SALES_ITEM);
    this.clearLineItem();
    this.lineItemFormSubmitted = false;
  }

  removeLineItem(index: number) {
    const item = this.lineItems.at(index)?.value;
    const tripId = item?.reference?.id;
    this.lineItems.removeAt(index);
    if (tripId) {
      this.selectedTrips = this.selectedTrips.filter((t: any) => t.id !== tripId);
      this.updateInvoiceFromSelectedTrips();
    }
  }

  clearAllLineItems() {
    this.lineItems.clear();
  }

  clearLineItem() {
    this.invoiceItemForm.patchValue({
      DetailType: "SalesItemLineDetail",
      Description: '',
      reference: {
        name: '',
        id: '',
        type: ''
      },
      Amount: 0,
      SalesItemLineDetail: {
        ItemRef: {
          value: '',
          name: ''
        },
        UnitPrice: 0,
        ServiceDate: moment().tz(this.user.timeZone).toISOString()
      },
      type: 'normal'
    });
  }

  // --- Helper method to create a LineItem form group ---
  private createLineItemForm(type: any): FormGroup {
    if (type === LineItemType.SALES_ITEM) {
      return this.fb.group({
        DetailType: ['SalesItemLineDetail'],
        Description: [''],
        reference: this.fb.group({
          name: [''],
          id: [''],
          type: ['']
        }),
        Amount: [0, [Validators.required, Validators.min(1)]],
        SalesItemLineDetail: this.fb.group({
          ItemRef: this.fb.group({
            name: [''],
            value: ['', Validators.required],
          }),
          Qty: [1, Validators.required],
          UnitPrice: [0, [Validators.required, Validators.min(1)]],
          ServiceDate: ['', Validators.required]
        })
      });
    } else {
      // type: description
      return this.fb.group({
        DetailType: ['DescriptionOnly'],
        Description: ['', Validators.required],
        reference: this.fb.group({
          name: [{ value: '', disabled: true }],
          id: [{ value: '', disabled: true }],
          type: [{ value: '', disabled: true }]
        }),
        Amount: [{ value: 0, disabled: true }],
        SalesItemLineDetail: this.fb.group({
          ItemRef: this.fb.group({
            name: [{ value: '', disabled: true }],
            value: [{ value: '', disabled: true }],
          }),
          Qty: [{ value: 0, disabled: true }],
          UnitPrice: { value: 0, disabled: true },
          ServiceDate: [{ value: '', disabled: true }]
        })
      });
    }
  }

  calculateProductAmount(unitPrice: number, quantity: number) {
    return unitPrice * quantity;
  }

  calculateAmount(evt: any, idx: number) {
    const product = this.lineItems.at(idx).value;
    if (product.DetailType !== LineItemType.SALES_ITEM) {
      return;
    }
    const unitPrice = product.SalesItemLineDetail.UnitPrice || 0;
    const quantity = product.SalesItemLineDetail.Qty || 0;
    this.lineItems.at(idx).patchValue({
      Amount: this.calculateProductAmount(unitPrice, quantity) || 0,
    });
    // console.log(evt.target.value);
  }

  // ======================= Line Item Ends =======================

  createLineItemForTrip(res: any) {
    if (!this.productItems?.length) return null;
    const ServiceDate = moment(res.pickup?.time).tz(this.user.timeZone).toISOString();
    let { reference, UnitPrice, IncomeAccountRef, Id, Description = '', Sku } = this.productItems[0];

    Description = `
Trip Id: ${this.titleCase.transform(res.reference) ?? 'N/A'}
Name: ${this.titleCase.transform(res.member?.firstName ?? '')} ${this.titleCase.transform(res.member?.lastName ?? '')}
Status: ${this.titleCase.transform(res.status ?? 'N/A')}
Spacetype: ${this.titleCase.transform(this.preSpacetypes?.[res.spaceType]?.title ?? 'N/A')}
PU: ${this.titleCase.transform(res.pickup?.address?.name ?? 'N/A')}
DO: ${this.titleCase.transform(res.destination?.address?.name ?? 'N/A')}
Distance: ${res.miles ?? 'N/A'}
`.trim();

    let addonsDescription = '';
    for (const addon of res.addons ?? []) {
      addonsDescription += `${this.titleCase.transform(this.preAddons?.[addon.addon]?.title ?? 'N/A')}(ICD: ${this.titleCase.transform(this.preAddons?.[addon.addon]?.code ?? 'N/A')}) - Quantity: ${addon.quantity ?? 0} \n`;
    }
    if (addonsDescription) {
      Description += '\nAddon:\n' + addonsDescription;
    }

    if (res.fare) {
      if (res.status === 'completed') {
        let newFare = { baseFare: res.fare.baseFare?.fare || 0, perMile: res.fare.perMile };
        if (res.fare.zoneBreakdown) {
          newFare.baseFare = res.fare.zoneBreakdown.baseFare;
          newFare.perMile = res.fare.zoneBreakdown.fare;
        }

        UnitPrice = res.preSpecialRate && res.preSpecialRate > 0 ? res.preSpecialRate || 0 : res.fare.total || 0;
        Description += `\nFare(${this.titleCase.transform(res.status)}): 
       Base Rate (ICD: ${res.fare.baseFareCode ?? 'N/A'}): ${newFare.baseFare ?? 'N/A'}
       Per Mile Rate (ICD: ${res.fare.perMileCode ?? 'N/A'}): ${newFare.perMile ?? 'N/A'}
       `;
      } else if (res.status === 'cancelled' && res.flags && res.flags.isBillable) {
        if (res.flags.isNoShow) {
          Description += `\nFare(${res.status}):  
                  No-Show/Dry Run (ICD: ${res.fare.dryRunCode ?? 'N/A'}): ${res.fare.noShowCharges?.value ?? 'N/A'}
       `;
          UnitPrice = res.fare.cancelBreakdown?.noShowCharges || 0;
        } else {
          Description += `\nFare(${res.status}):  
       Cancel Rate: ${res.fare.cancelCharges?.value ?? 'N/A'}
       `;
          UnitPrice = res.fare.cancelBreakdown?.cancelCharges || 0;
        }
      }
    } else {
      UnitPrice = 0;
    }

    if (res.fare) {
      Description += `\nFare: ${res.fare.total ?? 0} | Pre Special Fare: ${res.preSpecialRate || 0} | Cancel Rate: ${res.fare.cancelBreakdown?.cancelCharges ?? 0} | No-Show Rate: ${res.fare.cancelBreakdown?.noShowCharges ?? 0}`;
      Description += `\nRate Applied(${this.titleCase.transform(res.status)}): ${UnitPrice}`;
    }

    const lineItem = this.createLineItemForm(LineItemType.SALES_ITEM);
    lineItem.patchValue({
      reference: {
        name: `${res.member?.displayName || ''}-${res.reference || ''}`,
        id: res.id,
        type: 'trip'
      },
      Amount: 1 * UnitPrice,
      Description: Description,
      SalesItemLineDetail: {
        ItemRef: { value: Id, name: IncomeAccountRef?.name },
        Qty: 1,
        UnitPrice,
        ServiceDate
      }
    });

    return lineItem;
  }

  addTripLineItem(trip: any) {
    if (!trip?.id) return;
    const exists = this.lineItems.controls.some(
      (ctrl: any) => ctrl.get('reference.id')?.value === trip.id
    );
    if (!exists) {
      const lineItem = this.createLineItemForTrip(trip);
      if (lineItem) {
        this.lineItems.push(lineItem);
      }
    }
  }

  removeTripLineItem(tripId: any) {
    if (!tripId) return;
    const index = this.lineItems.controls.findIndex(
      (ctrl: any) => ctrl.get('reference.id')?.value === tripId
    );
    if (index > -1) {
      this.lineItems.removeAt(index);
    }
  }

  updateInvoiceFromSelectedTrips() {
    this.recalculateSelectedTripsTotal();
    if (!this.selectedTrips?.length) {
      this.invoiceForm.get('reference')?.patchValue({
        name: '',
        id: ''
      });
      return;
    }

    const nameReference = this.selectedTrips
      .map((trip: any) => `${trip.member?.displayName || ''}-${trip.reference?.toString() || ''}`)
      .filter(Boolean)
      .join(', ');
    const tripIds = this.selectedTrips
      .map((t: any) => t.id?.toString())
      .filter(Boolean)
      .join(', ');
    const firstTrip = this.selectedTrips[0];
    this.invoiceForm.get('reference')?.patchValue({
      name: nameReference,
      id: tripIds
    });

    if (firstTrip) {
      const preFundingSource = this.preFundingSource?.[firstTrip.fundingsource];
      const matchedCustomer = preFundingSource
        ? this.allCustomers.find((c: any) => String(c.reference?.id) === String(preFundingSource.id))
        : null;

      this.invoiceForm.patchValue({
        CustomerRef: { name: matchedCustomer?.DisplayName || '', value: matchedCustomer?.Id || '' },
        DueDate: moment(firstTrip.pickup?.time).tz(this.user.timeZone).add(1, 'month').toISOString(),
        BillEmail: { Address: matchedCustomer?.PrimaryEmailAddr?.Address || getCompanyEmail(this.user?.company) || '' }
      });
    }
  }

  onSelectTrips(event: any) {
    if (!event) return;

    if (event.action === 'toggle') {
      if (event.isSelected) {
        this.addTripLineItem(event.trip);
      } else {
        this.removeTripLineItem(event.trip?.id);
      }
      this.selectedTrips = event.selectedTrips || [];
      this.updateInvoiceFromSelectedTrips();
    } else if (event.action === 'selectAll') {
      if (event.isSelected) {
        (event.trips || []).forEach((trip: any) => this.addTripLineItem(trip));
      } else {
        (event.trips || []).forEach((trip: any) => this.removeTripLineItem(trip.id));
      }
      this.selectedTrips = event.selectedTrips || [];
      this.updateInvoiceFromSelectedTrips();
    } else if (event.action === 'clearAll') {
      (this.selectedTrips || []).forEach((trip: any) => this.removeTripLineItem(trip.id));
      this.selectedTrips = [];
      this.updateInvoiceFromSelectedTrips();
    } else if (Array.isArray(event)) {
      this.selectedTrips = event;
      const selectedIds = new Set(event.map((t: any) => t.id));

      for (let i = this.lineItems.length - 1; i >= 0; i--) {
        const refId = this.lineItems.at(i).get('reference.id')?.value;
        const refType = this.lineItems.at(i).get('reference.type')?.value;
        if (refType === 'trip' && refId && !selectedIds.has(refId)) {
          this.lineItems.removeAt(i);
        }
      }

      for (const trip of event) {
        this.addTripLineItem(trip);
      }
      this.updateInvoiceFromSelectedTrips();
    }
  }


  /** Sum of the Amount already on each trip line item — display only, no fare logic here. */
  private recalculateSelectedTripsTotal() {
    this.selectedTripsTotal = this.lineItems.controls
      .filter((ctrl: any) => ctrl.get('reference.type')?.value === 'trip')
      .reduce((sum: number, ctrl: any) => sum + (Number(ctrl.get('Amount')?.value) || 0), 0);
  }

  onSetGlobalLineItemType(event: any) {
    this.globalLineItemType = event;
  }

  openTripDetailsModal(tripId: any) {
    this.tripId = tripId;
  }
}
